
export const fadeUp = {
  hidden: { y: 12, opacity: 0 },
  show:   { y: 0,  opacity: 1, transition: { type: "spring", stiffness: 260, damping: 24 } },
};

// Simple fade in
export const fadeIn = {
  hidden: { opacity: 0 },
  show:   { opacity: 1, transition: { duration: 0.3 } },
};

// Form enter + optional shake on error
export const formEnter = {
  initial: { y: 56, opacity: 0, scale: 0.98 },
  ready:   {
    y: 0, opacity: 1, scale: 1,
    transition: { type: "spring", stiffness: 220, damping: 24 }
  },
  shake:   {
    x: [0, -10, 10, -8, 8, -4, 4, 0],
    transition: { duration: 0.45 }
  },
};

// Nice hover/tap micro-interactions
export const hoverRaise = {
  whileHover: { y: -1, scale: 1.005 },
  whileTap:   { scale: 0.985 },
};
export const hoverLiftButton = {
  whileHover: { y: -1, scale: 1.01 },
  whileTap:   { scale: 0.985 },
};

// Parent stagger container
export function staggerContainer(stagger = 0.08, delayChildren = 0.1) {
  return {
    hidden: { opacity: 0 },
    show:   { opacity: 1, transition: { staggerChildren: stagger, delayChildren } },
  };
}

// Slide-in helper
export function slideInFrom(direction = "left", distance = 20) {
  const axis = direction === "left" || direction === "right" ? "x" : "y";
  const sign = (direction === "left" || direction === "up") ? -1 : 1;
  return {
    hidden: { [axis]: sign * distance, opacity: 0 },
    show:   { [axis]: 0, opacity: 1, transition: { type: "spring", stiffness: 240, damping: 24 } },
  };
}

// Slow drifting animation for background blobs/glows
export function drift({ dx = [0, 10, -10, 0], dy = [0, 10, -6, 0], duration = 14, ease = "easeInOut" } = {}) {
  return {
    animate: { x: dx, y: dy },
    transition: { duration, repeat: Infinity, ease },
  };
}

// Add delay to an existing variants object (shallow)
export function withDelay(variants, delay = 0) {
  const out = {};
  for (const k in variants) {
    const v = variants[k];
    out[k] = { ...v, transition: { ...(v?.transition || {}), delay: ((v?.transition?.delay) || 0) + delay } };
  }
  return out;
}
// --- Header entrance (sticky top bar) ---
export const headerEnter = {
  hidden: { y: -14, opacity: 0 },
  show: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 180, damping: 22, delayChildren: 0.05, staggerChildren: 0.06 }
  },
};

export const headerItem = {
  hidden: { y: -6, opacity: 0 },
  show:   { y: 0, opacity: 1, transition: { type: "spring", stiffness: 220, damping: 22 } },
};

// --- Page (route) transitions for <Outlet/> ---
export const pageV = {
  initial: { y: 12, opacity: 0 },
  animate: { y: 0,  opacity: 1, transition: { type: "spring", stiffness: 220, damping: 28 } },
  exit:    { y: -6, opacity: 0, transition: { duration: 0.18 } },
};

// --- Micro interactions (buttons/icons) ---
export const microTap = {
  whileHover: { y: -1, scale: 1.02 },
  whileTap:   { scale: 0.98 },
};

// --- Reusable spring for layoutId “active pill” in sidebar ---
export const navPillSpring = { type: "spring", stiffness: 220, damping: 26 };

// --- Mobile drawer + overlay (if you animate the sidebar) ---
export const drawerSlide = {
  hidden: { x: -320 },
  show:   { x: 0, transition: { type: "spring", stiffness: 260, damping: 28 } },
  exit:   { x: -320, transition: { duration: 0.2 } },
};

export const overlayFade = {
  hidden: { opacity: 0 },
  show:   { opacity: 1, transition: { duration: 0.18 } },
  exit:   { opacity: 0, transition: { duration: 0.18 } },
};

// --- Card/glass rise (nice for panels/cards) ---
export const glassRise = {
  hidden: { y: 10, opacity: 0 },
  show:   { y: 0,  opacity: 1, transition: { type: "spring", stiffness: 200, damping: 22 } },
};

